const Loader = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="flex flex-col items-center justify-center">
        <div className="w-10 h-10 mb-4 border-t-4 border-solid rounded-full border-primary animate-spin"></div>
      </div>
    </div>
  );
};

export default Loader;
